// extracted by mini-css-extract-plugin
module.exports = {"grid":"indexPrivacy_grid__J32cR","text":"indexPrivacy_text__tKJtR"};